module.exports = __webpack_public_path__ + "img/taegeuk.1e4418fa.svg";